<template>
    <div class="container" :style="{ backgroundImage: 'url(' + imgUrl + ')' }">
        <div class="box">
            <h3 class="title reveal-bottom">{{ $t("cxc.t") }}</h3>
            <div class="img1 reveal-bottom">
                <img
                    style="width:1200px;"
                    :src="
                        lang === 'en_US'
                            ? require('@/assets/img_svg/cloud_xpress_connect_img_1_en.png')
                            : require('@/assets/img_svg/cloud_xpress_connect_img_1_cn.png')
                    "
                    alt="svg"
                />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            imgUrl: require("@/assets/images/cloud_xpress_connect_banner_bg.jpg"),
            lang: localStorage.getItem("lang"),
        };
    },
    mounted() {
        this.$bus.$on("lang", (lang) => (this.lang = lang));
    },
};
</script>
<style scoped>
.container {
    height: 1030px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    overflow: hidden;
}
.box {
    width: 1200px;
    margin: auto;
    padding: 0 10px;
    box-sizing: border-box;
}
.title {
    font-size: 44px;
    color: #fff;
    letter-spacing: 0;
    line-height: 66px;
    margin-top: 184px;
}

.img {
    width: 1180px;
    height: 518px;
    margin-bottom: 180px;
}
.img1 {
    width: 1180px;
    height: 518px;
    margin-top: 104px;
    margin-bottom: 180px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/CloudXpressConnect/Content0.vue